import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import NewsLetterNavbar from "../components/NewLetterNavbar";
import NewsLetterTable from "../components/NewsLetterTable";

const NewsLetter = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <NewsLetterNavbar sidebarOpen={sidebarOpen} />
      <NewsLetterTable sidebarOpen={sidebarOpen} />
    </div>
  );
};

export default NewsLetter;
